import { parameterDateFormat } from 'constants/suspensionConstants';

export const SuspensionAlertMessageSessionStorageKey = 'SuspensionAlertMessage';

export const setSuspensionAlertMessage = (obj) => {
  sessionStorage.setItem(
    SuspensionAlertMessageSessionStorageKey,
    JSON.stringify(obj)
  );
};

export const getSuspensionAlertMessage = () => {
  return JSON.parse(
    sessionStorage.getItem(SuspensionAlertMessageSessionStorageKey)
  );
};

export const removeSuspensionAlertMessage = () => {
  sessionStorage.removeItem(SuspensionAlertMessageSessionStorageKey);
};

export const setSuspensionWarningMessage = (title) => {
  setSuspensionAlertMessage({
    variant: 'warning',
    title:
      title ||
      'The suspension does not exist or you do not have permission to access it.',
  });
};

export const getSuspensionFormData = (formValues, defaultValues) => {
  const {
    suspensionFee,
    chargeForSuspension,
    suspensionPaymentFrequency,
  } = defaultValues;
  const formData = {
    suspensionStartDate:
      formValues.suspensionStartDate &&
      formValues.suspensionStartDate.format(parameterDateFormat),
    suspensionEndDate:
      formValues.suspensionEndDate &&
      formValues.suspensionEndDate.format(parameterDateFormat),
    chargeForSuspension:
      formValues.chargeForSuspension === undefined
        ? chargeForSuspension
        : formValues.chargeForSuspension,
    suspensionFee:
      formValues.suspensionFee === undefined
        ? suspensionFee
        : formValues.suspensionFee,
    suspensionPaymentFrequency:
      formValues.suspensionPaymentFrequency === undefined
        ? suspensionPaymentFrequency
        : formValues.suspensionPaymentFrequency,
    suspensionReason: formValues.suspensionReason,
  };
  return formData;
};
